import llGatewayCelebrationComponent from "components/ll-gateway-celebration-component";
import Components from "slotworks/components/components";
import { Services } from "slotworks/services/services";
import State from "slotworks/state-machine/states/state";
import Sequence from "slotworks/utils/contracts/sequence";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";

export default class CGGatewayCelebration extends State {

    public onEnter() {
        lightningBorderAnimationUtil.stop();

        new Sequence([
            () => Services.sound.customEventContract("bonus_bell"),
            () => llGatewayCelebrationComponent.playFreespinsCelebration()
        ]).then(() => {
            Components.matrix.resetSymbols();
            this.complete();
        });

        // TODO: footer message
        // Components.footer.showFreeSpinsTriggered(freespinsWon);
    }
}
